import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZuperDrawerComponent } from './zuper-drawer.component';

@NgModule({
    declarations: [
        ZuperDrawerComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ZuperDrawerComponent
    ]
})
export class ZuperDrawerModule {
}
